// extracted by mini-css-extract-plugin
module.exports = {"wrapCheckbox":"FormikCheckBox_wrapCheckbox__CMeTa","wrapInput":"FormikCheckBox_wrapInput__3o8CF"};